// src/store.js

import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/Reducer';
import authMiddleware from '../middleware/authMiddleware';
import tokenMiddleware from '../middleware/tokenMiddleware';
import timerMiddleware from '../middleware/timerMiddleware';

const store = createStore(
    rootReducer,
    applyMiddleware(thunk, authMiddleware, tokenMiddleware, timerMiddleware)
);

export default store;
